import { integer, object, string } from 'superstruct';
export const ViewArcRoleBaseMemberDto = object({
  id: integer(),
  name: string(),
  avbId: string()
});